/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */

/**
 * Transaction OCR status as seen by the client.
The server-side model has four states (waiting, processing, input_done,
failed). `waiting` and `processing` are indistinguishable to the client,
so the server collapses them into `processing` before responding.

 */
export type ApReceivedInvoiceTransactionOcrStatus =
  | (typeof ApReceivedInvoiceTransactionOcrStatus)[keyof typeof ApReceivedInvoiceTransactionOcrStatus]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApReceivedInvoiceTransactionOcrStatus = {
  processing: 'processing',
  success: 'success',
  failure: 'failure',
} as const;
